export enum UserType {
    Guest = "G",
    User = "U",
}
